import axios from '@/core/axios';

import { CollectionList } from '../collections/collections.types';
import { PaymentLink, PaymentLinksListOptions } from './payment-links.types';

export class PaymentLinksService {
  async list(opts: PaymentLinksListOptions = {}): Promise<CollectionList<'payment-links'>> {
    const { filters, pagination } = opts;
    const resp = await axios.get<CollectionList<'payment-links'>>('/payment-links', {
      params: { ...filters, ...pagination }
    });
    return resp?.data;
  }

  async get(id: number): Promise<PaymentLink> {
    const resp = await axios.get<PaymentLink>(`/payment-links/${id}`);
    return resp?.data;
  }

  // No-op placeholder to mirror the BuybackService shape (used by the table store via collection service)
  update;

  async forceDone(id: number): Promise<PaymentLink> {
    const resp = await axios.patch<PaymentLink>(`/payment-links/${id}/force-done`);
    return resp?.data;
  }
}

export const paymentLinksService = new PaymentLinksService();
